import { dateTimeFormater } from "../../../../utilities/formaters";

const TableCellDate = ({ value }) => {
  let date = "";
  if (value) date = dateTimeFormater(value);
  return <div className="table-cell-date">{date}</div>;
};

export default TableCellDate;
